import React from 'react';

export default function NotFound() {
  return (
    <div style={{ padding: 24, textAlign: 'center' }}>
      <h1>404</h1>
      <p>Page not found.</p>
    </div>
  );
}
